import { Handshake, TrendingUp, Users, Filter } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const PILLARS = [
    {
        icon: Handshake,
        title: "One team, not two vendors",
        desc: "No disconnect between the creator agency and the performance media buyers. Unified accountability for ROAS.",
    },
    {
        icon: TrendingUp,
        title: "Proven reach — 1B+ views",
        desc: "Battle-tested campaign structures running since 2018, with frameworks that scale.",
    },
    {
        icon: Users,
        title: "Real creator depth — 3,200+",
        desc: "Direct relationships across Tier A, B and C creators with regional-language coverage.",
    },
    {
        icon: Filter,
        title: "Full-funnel thinking",
        desc: "From top-of-funnel viral attention down to retargeting and bottom-line CPA performance.",
    },
];

export default function WhyFocs() {
    return (
        <section id="why" data-testid="why-section" className="border-t border-line bg-white py-16 sm:py-24">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <Reveal className="mb-12 max-w-3xl">
                    <Eyebrow tone="light">Why FocS</Eyebrow>
                    <h2 className="mt-4 font-syne text-3xl font-bold tracking-tight text-ink sm:text-5xl">
                        Built different,
                        <br />
                        on purpose.
                    </h2>
                </Reveal>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                    {PILLARS.map((p, i) => (
                        <Reveal key={p.title} delay={i * 0.08} className="h-full" testid={`why-card-${i + 1}`}>
                            <div className="group flex h-full flex-col rounded-3xl bg-ink p-8 transition-transform duration-300 hover:-translate-y-1 sm:p-10">
                                <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-crimson to-flame text-white shadow-lg shadow-crimson/30">
                                    <p.icon className="h-5 w-5" />
                                </div>
                                <h3 className="font-syne text-xl font-bold tracking-tight text-white sm:text-2xl">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                                    {p.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
